/* Vipejar Home V2 — progressive motion only, 2026-08-05 */
(function () {
  "use strict";

  var root = document.querySelector(".vp2");
  if (!root || root.dataset.vp2Ready === "true") return;
  root.dataset.vp2Ready = "true";

  var revealNodes = Array.prototype.slice.call(
    root.querySelectorAll("[data-vp2-reveal]"),
  );
  var reduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduced || !("IntersectionObserver" in window)) {
    revealNodes.forEach(function (node) {
      node.classList.add("is-visible");
    });
  } else {
    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -9% 0px", threshold: 0.08 },
    );

    revealNodes.forEach(function (node) {
      revealObserver.observe(node);
    });
  }

  var scenes = Array.prototype.slice.call(
    root.querySelectorAll("[data-vp2-scene]"),
  );
  var setProgress = function () {
    var max = Math.max(
      1,
      document.documentElement.scrollHeight - window.innerHeight,
    );
    var progress = Math.min(100, Math.max(0, (window.scrollY / max) * 100));
    root.style.setProperty("--vp2-progress", progress.toFixed(2) + "%");
  };

  var ticking = false;
  var onScroll = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      setProgress();
      ticking = false;
    });
  };

  setProgress();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });

  if ("IntersectionObserver" in window) {
    var sceneObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting)
            root.dataset.vp2CurrentScene = entry.target.dataset.vp2Scene || "";
        });
      },
      { rootMargin: "-35% 0px -45% 0px", threshold: 0 },
    );
    scenes.forEach(function (scene) {
      sceneObserver.observe(scene);
    });
  }
})();
